export default function CarouselSection() {
  const items = [
    {
      id: 1,
      title: '2026国漫暑期档热播精选',
      desc: '盘点本季最受关注的国产动画新番，从热血战斗到治愈日常，多部高分动漫同步更新中。51动漫网持续收录最新话资源，助你不错过任何精彩瞬间。',
      tag: '热门专题',
      image: 'https://readdy.ai/api/search-image?query=Epic%20anime%20scene%20with%20multiple%20characters%20in%20dynamic%20action%20poses%2C%20warm%20golden%20lighting%2C%20dramatic%20composition%2C%20vibrant%20red%20and%20orange%20color%20scheme%2C%20anime%20art%20style%2C%20heroic%20atmosphere%2C%20cinematic%20quality%2C%20clean%20illustration%20with%20detailed%20background&width=800&height=500&seq=carousel-1-anime&orientation=landscape',
    },
    {
      id: 2,
      title: '经典国漫怀旧特辑：童年回忆杀',
      desc: '回顾那些陪伴一代人成长的经典国产动画，从水墨风到现代CG，感受国漫发展历程中的里程碑作品。51动漫网站为你整理全部经典资源。',
      tag: '经典回顾',
      image: 'https://readdy.ai/api/search-image?query=Nostalgic%20anime%20scene%20with%20traditional%20Chinese%20ink%20painting%20style%2C%20soft%20warm%20colors%2C%20serene%20landscape%20with%20mountains%20and%20bamboo%2C%20elegant%20character%20in%20flowing%20robes%2C%20gentle%20golden%20light%2C%20artistic%20composition%2C%20beautiful%20Chinese%20aesthetic&width=800&height=500&seq=carousel-2-anime&orientation=landscape',
    },
    {
      id: 3,
      title: '国产3D动画技术突破：视觉盛宴',
      desc: '近年来国产3D动画制作技术飞速发展，多部作品以精湛的画面表现和流畅的动作设计赢得口碑。51动漫主页第一时间更新最新话资源。',
      tag: '技术前沿',
      image: 'https://readdy.ai/api/search-image?query=Futuristic%203D%20anime%20scene%20with%20stunning%20visual%20effects%2C%20glowing%20energy%20particles%2C%20detailed%20sci-fi%20environment%2C%20dynamic%20character%20with%20armor%2C%20warm%20amber%20and%20crimson%20lighting%2C%20cinematic%20composition%2C%20high%20quality%20CG%20render&width=800&height=500&seq=carousel-3-anime&orientation=landscape',
    },
    {
      id: 4,
      title: '原创国漫崛起：新生代创作者盘点',
      desc: '国产原创动漫正在迎来黄金时代，越来越多优秀的独立创作者和工作室崭露头角。51动漫官网为你推荐值得关注的原创国漫新星。',
      tag: '原创力量',
      image: 'https://readdy.ai/api/search-image?query=Creative%20anime%20illustration%20with%20diverse%20original%20characters%20in%20a%20colorful%20urban%20setting%2C%20warm%20sunset%20lighting%2C%20vibrant%20red%20and%20gold%20tones%2C%20modern%20art%20style%2C%20dynamic%20composition%2C%20inspiring%20atmosphere%2C%20clean%20illustration&width=800&height=500&seq=carousel-4-anime&orientation=landscape',
    },
  ];

  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            深度解读国产动漫最新动向，为你呈现最值得关注的动漫专题内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {items.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-[220px] md:h-[260px] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`51动漫 - ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}